import { useTRPC } from "../../../../trpc/client";
import { useQuery } from "@tanstack/react-query";
import { FiltersType } from "../types/filters.type";
import { useMemo } from "react";
import { useMerchant } from "../../../../hooks/useMerchant";

export function useFetchCustomers(filters: FiltersType, cursor?: string) {
  const { merchant } = useMerchant();
  const trpc = useTRPC();

  const queryFilters = useMemo(
    () => ({
      rentalsMerchantId: merchant?.id ?? "",
      documentNumber: filters.clientId?.trim() || undefined,
      muted:
        filters.whatsAppFilter === "Habilitado"
          ? false
          : filters.whatsAppFilter === "Deshabilitado"
          ? true
          : undefined,
      cursor,
    }),
    [merchant?.id, filters, cursor]
  );

  const { data, isPending, refetch } = useQuery({
    ...trpc.customers.list.queryOptions(queryFilters),
    enabled: !!merchant?.id,
    refetchInterval: 120_000,
  });

  const customers = data?.customers || [];
  const nextCursor = data?.cursor || undefined;
  const totalItems = customers.length || 0;

  return {
    customers,
    nextCursor,
    totalItems,
    isLoading: isPending,
    refetch,
  };
}
